<script setup>
import { useCollectionStore } from '../pinia/CollectionStore'

const CollectionStore = useCollectionStore()

CollectionStore.setupCollection()
</script>
